import Extension from "../base/extension";

class AppBackInStock extends Extension {
  data = {
    selectors: {
      button: ".product-back-in-stock-form button",
    }
  }

  constructor(name) {
    super(name);
  }

  onReady() {
    document.querySelectorAll(this.data.selectors.button).forEach(e => {
      e.addEventListener("click", this.onBISFormSubmitted.bind(this));
    });
  }

  onBISFormSubmitted(e) {
    e.preventDefault();
    let bisContainer = e.target.closest(".product-back-in-stock-form");
    //let productForm = Stencil.Extensions.ProductFormManager.forms[e.target.closest(".product-container").id];
    let productForm = bisContainer.closest("product-details");

    let email = bisContainer.querySelector("input[type='email']").value;
    let acceptsMarketing = bisContainer.querySelector("input[type='checkbox']").checked;
    let variantId = productForm.querySelector("product-options-picker").currentVariant.id;
    let productId = productForm.product.id;
    let attributes = { accepts_marketing: acceptsMarketing };
    if(!email || !variantId || !productId){
      console.error("[A-B-I-S] Failed to get necessary BIS data");  
    }

    BIS.create(email, variantId, productId, attributes).then(resp => {
      this.handleBISResponse(resp, bisContainer); 
    });
  }

  handleBISResponse(resp, bisContainer) {
    let bisResponseContainer = bisContainer.querySelector(".product-back-in-stock-response");
    switch(resp.status){
      case "Error":
        bisResponseContainer.classList.replace("alert-success", "alert-danger");
        let errors = [];
        Object.keys(resp.errors).forEach(function(k){
          errors = errors.concat(resp.errors[k]);
        });
        bisResponseContainer.innerText = errors.join(', ');
        break;
      case "OK":
        bisResponseContainer.classList.replace("alert-danger", "alert-success");
        bisResponseContainer.innerText = resp.message;
        bisContainer.querySelector("button").disabled = true;
        bisContainer.querySelector("button").innerHTML = "Registered!";
        break;
    }
    bisResponseContainer.classList.remove("d-none");
  }
}

export default AppBackInStock;